import { render } from "./GeneralThankYou.vue?vue&type=template&id=fe523e86"
import script from "./GeneralThankYou.vue?vue&type=script&lang=js"
export * from "./GeneralThankYou.vue?vue&type=script&lang=js"

import "./GeneralThankYou.vue?vue&type=style&index=0&id=fe523e86&lang=css"
script.render = render

export default script